export default "__VITE_ASSET__97f9828d__"